import { Alert } from 'antd';
import { CustomerServiceOutlined } from '@ant-design/icons';

export default function BalanceRecharge() {
  return (
    <Alert
      type="info"
      showIcon
      icon={<CustomerServiceOutlined />}
      message="如需充值请联系客服 @BJzhaocaimao"
      className="text-base"
    />
  );
}
